<template>
    <ConfirmDialog group="dialog" />
    <div class="p-grid">
        <!-- <div class="p-col-12 p-pb-0">
            <Button @click="$router.go(-1)" label="Go Back" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
        </div> -->
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('ReportManagement.list.Report Details')}}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('ReportManagement.list.Product Name')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.product_name }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('ReportManagement.list.Product Category')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.product_category }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('ReportManagement.list.Label')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.description }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('ReportManagement.list.Date & Time')}}:</label>
                    <div class="p-col-12 p-md-10">{{ formatDateTime(mydata.created_date) }}</div>
                </div>
                
                <div class="p-d-flex p-jc-end">
                    <!-- <router-link to="/view-user"
                        ><Button label="info" class="p-button-outlined p-button-info p-mr-2 p-mb-2" disabled><i class="pi pi-eye p-mr-2"></i>point</Button>
                    </router-link>-->
                    <!-- <router-link :to="'/faq/edit/' + $route.params.id">
                        <Button label="help" class="p-button-outlined p-button-help p-mr-2 p-mb-2"> <i class="pi pi-user-edit p-mr-2"></i> Edit </Button>
                    </router-link> -->
                    <!-- <Button @click="reply()" label="Reply" class="p-button-outlined p-mr-2 p-mb-2" disable="disInq">Reply</Button> -->
                    <Button @click="$router.go(-1)" label="back" class="p-button-outlined p-button-danger p-mr-2 p-mb-2">Back </Button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import ReportService from '../../service/API/ReportService';
import formatDateTime from '../../mixin/mixinFunction';
// import {useRouter} from 'vue-router'
export default {
    mixins: [formatDateTime],
    data() {
        return {
            disInq:true,
            renderTxt: false,
            replied: false,
            replyText: '',
            replyStatus: 'answered',
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            mydata: {},
        };
    },
    created() {
        this.reportService = new ReportService();
    },
    methods: {
        reply() {
            if (this.replyText != '') {
                this.inquiryService.inquiryReply(this.$route.params.id, this.replyText, this.replyStatus).then((data) => {
                    console.log(data);
                });
            } else {
                alert('replay text should not blanck');
            }
        },
        del(id) {
            this.$confirm.require({
                group: 'dialog',
                header: 'Confirmation',
                message: 'Are you sure you want to delete?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    axios({ method: 'delete', url: `/faq/delete`, data: { deleteIdArray: id } }).then((res) => {
                        console.warn(res);
                        this.$router.push({ name: 'Faq' });
                    });

                    this.$toast.add({ severity: 'info', summary: 'Deleted', detail: 'Deleted successfully', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                },
            });
        },
    },
    mounted() {
        this.reportService.viewReport(this.$route.params.id).then((data) => {
            console.log(data);
            this.mydata = data;
           
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
.renderHtml {
    background-color: #fcfcfc;
    padding: 25px;
    border: 1px solid rgba(70, 77, 242, 0.2);
    border-radius: 5px;
    margin-top: 15px;
}
</style>
